// extracted by mini-css-extract-plugin
export default {"priceFieldWrapper":"Chl9Iv","currency":"VGYvDJ","nameYourPriceField":"R5TwtL"};